import React from 'react';

interface CardDashboardTradesDividendsSectionProps {
    children: React.ReactNode;
}

export const CardDashboardTradesDividendsSection: React.FC<CardDashboardTradesDividendsSectionProps> = ({
    children,
}) => <div className="flex flex-col gap-xsmall">{children}</div>;
